import { DIAGRAM_EVENTS } from "../../../diagram/config/events.const";

/**
 * @description Handles the mouse scroll with click and scroll
 */
export class ScrollHandler {
    isDragging = false;

    camera;

    constructor(camera) {
        this.camera = camera;
    }

    /**
     * @description handles al lthe different mouse events in order to control scroll
     * @param {String} eventType - event name
     * @param {Object} payload - event payload
     * @param {CellIndependentPluginHandler} cellIndependentPluginHandler instance
     */
    eventHappened(eventType, payload, cellIndependentPluginHandler) {
        if (eventType === DIAGRAM_EVENTS.MOUSE_DOWN) {
            if (!this.isDragging) {
                this.camera.mouseDownPressed = true;
                this.camera.lastMouseDragPosition = payload.event;
            }
        } else if (eventType === DIAGRAM_EVENTS.MOUSE_UP) {
            this.camera.mouseDownPressed = false;
            this.camera.lastMouseDragPosition = null;
        } else if (eventType === DIAGRAM_EVENTS.MOUSE_WHEEL) {
            const deltaY = payload.wheelDelta ? payload.deltaY : payload.deltaY * 40 - 20;
            const deltaX = payload.wheelDelta ? payload.deltaX : (payload.deltaX ? payload.deltaX * 40 - 20 : payload.deltaX);
            const x = payload.shiftKey ? deltaY : deltaX;
            const y = payload.shiftKey ? deltaX : deltaY;
            this.camera.scrollbars.scrollBy(x, y);
        } else if (eventType === DIAGRAM_EVENTS.MOUSE_OUT) {
            if (this.camera.scrollbars.visible()) {
                this.camera.scrollbars.hide();
                this.camera.scrollbars.dragged = false;
                this.camera.draw();
            }
        } else if (eventType === DIAGRAM_EVENTS.MOUSE_OVER) {
            const rect = this.camera.canvas.getBoundingClientRect();
            const x = payload.event.clientX - rect.left;
            const y = payload.event.clientY - rect.top;
            if (payload.event && payload.event.buttons === 1) {
                this.camera.scrollbars.mousePosVertical = y;
                this.camera.scrollbars.mousePosHorizontal = x;
                this.camera.scrollbars.scroll();
            }
        } else if (eventType === DIAGRAM_EVENTS.MOUSE_MOVE) {
            // we're dragging something
            let deltaX; let
                deltaY;
            if (payload.event && payload.event.buttons === 1 && this.camera.mouseDownPressed) {
                const headerInstance = cellIndependentPluginHandler.checkForOpenedMenu(); // close header menu in Data Modelv
                if (headerInstance) {
                    headerInstance.closeImportExportMenu();
                }
                deltaX = this.camera.lastMouseDragPosition.clientX - payload.event.clientX;
                deltaY = this.camera.lastMouseDragPosition.clientY - payload.event.clientY;
                this.camera.scrollbars.scrollBy(deltaX, deltaY);
                this.camera.lastMouseDragPosition = payload.event;
            }
        }
    }
}
